import Address from '../../../AddressBuilder.js'
import HttpConfig from '../../../../request/HttpConfig'

const _path = {
  DMXXB: Address.business('bzdzDmxxb', Address.CONFIG.VERSION.version_1),
}

export default {

  listByKey(_parameter) {// 标准地址 关键字查询
    let config = HttpConfig.obtain().closeLoading().done()
    return sHttp.postJson(_path.DMXXB + 'listByKey', _parameter, config)
  },

  tree(_parameter) { // 标准地址tree
    return sHttp.postJson(_path.DMXXB + 'tree', _parameter)
  },

  add(_parameter) {// 标准地址新增
    return sHttp.postJson(_path.DMXXB + 'add', _parameter)
  },

  update(_parameter) {// 标准地址更新
    return sHttp.postJson(_path.DMXXB + 'update', _parameter)
  },

  delete(_parameter) {// 标准地址注销
    return sHttp.postJson(_path.DMXXB + 'delete', _parameter)
  },
}
